export default __webpack_public_path__ + "static/media/prev.2417ea04.svg";